// extracted by mini-css-extract-plugin
export var divider = "_2z-0";
export var dividerText = "_2z-1";